import type { ConfigPropertyValue } from "@/components/alfred/config-properties-panel"
import type { UpdateSmithersGlobalRequest } from "@/types/smithers-global"

export function toSmithersGlobalRequest(values: Record<string, ConfigPropertyValue | null>): UpdateSmithersGlobalRequest {
  if (values.validationVendor !== "ProVenue" && values.validationVendor !== "Orion") throw new Error("Select a validation vendor")
  const request: UpdateSmithersGlobalRequest = {
    validationVendor: values.validationVendor,
    facilityCode: "", venueId: "", areaCode: "", deviceCode: "", nteClubCode: "",
    matchThreshold: 0, validationTimeoutMs: 0,
  }
  for (const key of ["facilityCode", "venueId", "areaCode", "deviceCode", "nteClubCode"] as const) {
    if (typeof values[key] !== "string") throw new Error(`${key} must be a text value`)
    request[key] = values[key]
  }
  for (const key of ["matchThreshold", "validationTimeoutMs"] as const) {
    const value = values[key]
    const max = key === "matchThreshold" ? 2147483647 : Number.MAX_SAFE_INTEGER
    if (typeof value !== "number" || !Number.isSafeInteger(value) || value < 0 || value > max) throw new Error(`${key} must be an integer between 0 and ${max}`)
    request[key] = value
  }
  if (values.proVenueInstanceId !== "none") {
    const id = Number(values.proVenueInstanceId)
    if (!Number.isSafeInteger(id) || id <= 0) throw new Error("Select a valid ProVenue instance or None")
    request.proVenueInstanceId = id
  }
  return request
}
